
import { Dealer } from '@/types/dealer';

/**
 * Creates a map of dealer_id to latest price from quotations
 */
export const createLatestPricesMap = (quotations: any[], dealersData: any[]) => {
  const latestPrices = {};
  
  if (quotations && quotations.length > 0) {
    dealersData.forEach(dealer => {
      const dealerQuotations = quotations.filter(q => q.dealer_id === dealer.id);
      if (dealerQuotations.length > 0) {
        // Use percentage spread by default
        const quotation = dealerQuotations[0];
        latestPrices[dealer.id] = quotation.spread_type === 'FIXED' 
          ? quotation.spread_fixed 
          : quotation.spread_percentage;
      }
    });
  }
  
  return latestPrices;
};

/**
 * Transforms raw dealer data to Dealer objects
 */
export const transformDealersData = (
  dealersData: any[], 
  favoritesDealers: string[],
  latestPrices: Record<string, number>
): Dealer[] => {
  console.log('transformDealersData - Raw data sample:', dealersData.slice(0, 2).map(d => ({
    id: d.id,
    name: d.name,
    average_rating: d.average_rating,
    rating_count: d.rating_count
  })));

  return dealersData.map((dealer: any) => {
    // CRITICAL FIX: Get rating directly from average_rating field and ensure proper conversion
    let rating = 0;
    
    if (dealer.average_rating !== null && dealer.average_rating !== undefined) {
      // If it's a string, parse it
      if (typeof dealer.average_rating === 'string') {
        rating = parseFloat(dealer.average_rating);
        if (isNaN(rating)) rating = 0;
      }
      // If it's already a number, use it directly
      else if (typeof dealer.average_rating === 'number') {
        rating = dealer.average_rating;
      }
    }

    // Get rating count with proper conversion
    let rating_count = 0;
    if (dealer.rating_count !== null && dealer.rating_count !== undefined) {
      if (typeof dealer.rating_count === 'string') {
        rating_count = parseInt(dealer.rating_count);
        if (isNaN(rating_count)) rating_count = 0;
      } else if (typeof dealer.rating_count === 'number') {
        rating_count = dealer.rating_count;
      }
    }
    
    console.log(`transformDealersData - ${dealer.name}: rating=${rating}, rating_count=${rating_count}`);
    
    // Check if this dealer is in the user's favorites
    const isFavorite = favoritesDealers.includes(dealer.id);
    
    return {
      id: dealer.id,
      name: dealer.name,
      address: dealer.address,
      city: dealer.city,
      latitude: dealer.latitude,
      longitude: dealer.longitude,
      rating: rating,
      rating_count: rating_count, // Add rating_count field
      is_verified: dealer.activated || false, // Backwards compatibility
      activated: dealer.activated || false,
      isFavorite: isFavorite,
      buySpread: latestPrices[dealer.id] || undefined, // Keeping the property name for backward compatibility
      image_url: dealer.image_url,
      postal_code: dealer.postal_code,
      phone: dealer.phone,
      opening_hours: dealer.opening_hours,
      email: dealer.email,
      website: dealer.website,
      license: dealer.license
    };
  });
};
